import { usePaginatedQuery } from "@padi/lib/hooks/use-paginated-query";
import { Crop, CropType } from "../_types";
import { useQuery } from "@tanstack/react-query";
import { req } from "@padi/lib/api";

interface UseCropsProps {
  currentPage: number;
  pageSize: number;
  apiFilters: Record<string, string>;
  enabled?: boolean;
}

export function useCrops({
  currentPage,
  pageSize,
  apiFilters,
  enabled = true,
}: UseCropsProps) {
  return usePaginatedQuery<Crop>({
    section: "/public/crop-listings",
    currentPage,
    pageSize,
    filters: apiFilters,
    enabled,
  });
}

export const useFeaturedCrops = (limit = 4) => {
  const { data, isLoading, error } = usePaginatedQuery<Crop>({
    section: "/public/crop-listings",
    pageSize: limit,
    currentPage: 1,
    filters: { isFeatured: "true" },
  });
  return { data, isLoading, error };
};

export const useCropTypes = () => {
  return useQuery({
    queryKey: ["crop-types"],
    queryFn: () => req<CropType[]>("/public/crop-types"),
  });
};
